const { sha512 } = require('./../../tools/hash')

module.exports = stopMandate
async function stopMandate ({mandateId, requestId}) {
  const {merchantId, apiKey} = this

  const hash = await sha512(mandateId + merchantId + requestId + apiKey)

  const body = {
    merchantId,
    mandateId,
    requestId,
    hash
  }

  return this.fetch(this.endpoints.stopMandate, {
    method: 'POST',
    body: JSON.stringify(body)
  })
}
